import { getMarketData } from 'app-lib/apis/coingeckoApi'
import { Asset } from 'app-lib/assetUtils'
import AsyncData from 'app-lib/mobx/AsyncData'
import providerUtils from 'app-lib/providerUtils'
import { ChainId } from 'bzx-common/src/config/appConfig'
import { RootStore } from 'bzx-common/src/stores'
import * as mobx from 'mobx'

export default class OokiDetailsVM {
  static chainsWithOokiToken: ChainId[] = [1, 56, 137, 42161]
  marketData = new AsyncData(null, () => getMarketData(Asset.OOKI))
  rootStore: RootStore

  get ookiBalance() {
    const { userWallet } = this.rootStore
    return userWallet.indexedByAsset.OOKI?.amount
  }

  get canAddToken() {
    const { isConnected, chainId } = this.rootStore.web3Connection
    return isConnected && chainId && OokiDetailsVM.chainsWithOokiToken.includes(chainId)
  }

  addOokiToken() {
    const { chainId } = this.rootStore.web3Connection
    if (chainId && OokiDetailsVM.chainsWithOokiToken.includes(chainId)) {
      providerUtils.addToken(chainId, Asset.OOKI)
    }
  }

  getData() {
    if (this.canAddToken) {
      this.rootStore.userWallet.getBalances([Asset.OOKI])
    }
    !this.marketData.loaded && this.marketData.fetch()
  }

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore
    mobx.makeAutoObservable(this, undefined, { deep: false, autoBind: true })
  }
}
